import { ref } from 'vue'
import { auth, signInAnonymously } from '@/firebase/config'

const error = ref(null)
const user = ref(null)

const loginAnon = async () => {
  error.value = null

  signInAnonymously(auth)
    .then((userCredential) => {
    // Signed in
      user.value = userCredential.user
      error.value = null
      return user
    })
    .catch((err) => {
      console.log(err.message, err.code)
      error.value = 'Login Error: Sign in failed'
    })
}

const useLoginAnon = () => {
  return { error, loginAnon, user }
}

export default useLoginAnon
